module.exports = __webpack_public_path__ + "static/img/200214.16c52304.png";